<mat-action-list class="ninety-list">
  @for (section of orderedSections(); track i; let i = $index) {
    <button
      mat-list-item
      [attr.aria-label]="offersResync(section) ? 'Sync with facilitator' : 'Go to ' + section.name"
      class="meeting-section-link"
      [class.active]="isActive(section)"
      [class.offers-resync]="offersResync(section)"
      [matTooltip]="section.name"
      [matTooltipDisabled]="section.name.length < 60"
      (click)="onRowClicked(section, i)">
      @if (presenterSection()) {
        <div class="presenter-slot">
          @if (isPresenterSection(section)) {
            <terra-avatar
              size="medium"
              [initials]="presenterAvatar()?.userInitials"
              [src]="presenterAvatar()?.pictureURL">
              <terra-badge icon="microphone" color="brand" />
            </terra-avatar>
          }
        </div>
      }
      <div class="section-index">{{ i + 1 }}.</div>
      <div class="section-heading">
        <div class="section-title" [innerHTML]="section.name"></div>
        @if (offersResync(section)) {
          <small class="sync-hint">Sync with facilitator</small>
        }
      </div>
      <div class="section-time">
        @let elapsed = elapsedFor(section);
        @if (elapsed !== null) {
          <ninety-clock-timer [totalSeconds]="elapsed" [totalTimeAllotted]="section.duration" />
          <span>/</span>
        }
        <ninety-clock-timer [totalSeconds]="section.duration" />
      </div>
    </button>
  }
</mat-action-list>
